<template>
  <div class="main_box">
    <div class="step_box" v-show="!isFullScreen">
      <el-row :gutter="15">
        <el-col :span="6">
          <div class="check_success_box" v-if="basicCheck.IsComplete">
            <i class="el-icon-check"></i> 已完成
          </div>
          <div class="check_warning_box" v-if="!basicCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              basicCheck.NoCompleteMessages == ''
                ? '基本信息不完善'
                : basicCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              step_item_active: isActive === 1,
              step_item: isActive !== 1
            }"
            @click="stepClick(1)"
          >
            <span class="step_num hidden-sm-and-down">1.</span>
            <div class="step_content">
              <div class="step_title">基本信息</div>
              <div class="step_desc hidden-sm-and-down">
                问卷标题、类型、封面信息等
              </div>
            </div>
          </a>
        </el-col>
        <el-col :span="6" v-if="questionnaireInfo.MeetingVerify !== 1">
          <div class="check_success_box" v-if="userCheck.IsComplete">
            <i class="el-icon-check"></i> 已选答卷人
          </div>
          <div class="check_warning_box" v-if="!userCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              userCheck.NoCompleteMessages == ''
                ? '未选答卷人'
                : userCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              step_item_active: isActive === 2,
              step_item: isActive !== 2
            }"
            @click="stepClick(2)"
          >
            <span class="step_num hidden-sm-and-down">2.</span>
            <div class="step_content">
              <div class="step_title">答卷人员</div>
              <div class="step_desc hidden-sm-and-down">管理答卷人员</div>
            </div>
          </a>
        </el-col>
        <el-col :span="6">
          <div class="check_success_box" v-if="bodyCheck.IsComplete">
            <i class="el-icon-check"></i> 已添加题目
          </div>
          <div class="check_warning_box" v-if="!bodyCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              bodyCheck.NoCompleteMessages == ''
                ? '未添加题目'
                : bodyCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              step_item_active: isActive === 3,
              step_item: isActive !== 3
            }"
            @click="stepClick(3)"
          >
            <span
              class="step_num hidden-sm-and-down"
              v-if="questionnaireInfo.MeetingVerify !== 1"
            >
              3.
            </span>
            <span
              class="step_num hidden-sm-and-down"
              v-if="questionnaireInfo.MeetingVerify === 1"
            >
              2.
            </span>
            <div class="step_content">
              <div class="step_title">题目段落</div>
              <div class="step_desc hidden-sm-and-down">管理题目段落</div>
            </div>
          </a>
        </el-col>
        <el-col :span="6">
          <el-button
            type="primary"
            style="width: 80px; height: 70px; margin-top: 16px"
            :disabled="!isComplete"
            v-if="questionnaireInfo.State === 0"
            @click="startQuestionnaire()"
          >
            发布问卷
          </el-button>
        </el-col>
      </el-row>
    </div>
    <router-view
      :questionnaireInfo="questionnaireInfo"
      :meetingInfo="meetingInfo"
    />
  </div>
</template>
<script>
import questionnaireApi from '../../../../api/wj/questionnaire'
export default {
  name: 'EditQuestionnaire',
  components: {
  },
  data () {
    return {
      formTitle: '新增问卷',
      isActive: 1,
      basicCheck: {
        IsComplete: false,
        NoCompleteMessages: '基本信息不完善'
      },
      userCheck: {
        IsComplete: false,
        NoCompleteMessages: '未选答卷人'
      },
      bodyCheck: {
        IsComplete: false,
        NoCompleteMessages: '未添加题目'
      },
      isComplete: false,
      questionnaireInfo: {
        State: null,
        MeetingVerify: 1
      },
      isFullScreen: false
    }
  },
  provide () {
    return {
      checkQuestionnaire: this.checkQuestionnaire,
      getQuestionnaireInfo: this.getQuestionnaireInfo,
      routeChange: this.routeChange,
      switchFullScreen: this.switchFullScreen
    }
  },
  inject: ['homeSwitchFullScreen'],
  props: ['meetingInfo'],
  methods: {
    stepClick: function (step) {
      const _this = this
      _this.isActive = step
      switch (step) {
        case 1:
          if (this.$route.name.indexOf('create') !== -1) {
            _this.$router.push({ name: 'createQuestionnaireBasic', params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid } })
          } else {
            _this.$router.push({ name: 'editQuestionnaireBasic', params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid } })
          }
          break
        case 2:
          if (_this.$route.params.qid && _this.$route.params.qid !== '0') {
            if (this.$route.name.indexOf('create') !== -1) {
              _this.$router.push({ name: 'createQuestionnaireUser', params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid } })
            } else {
              _this.$router.push({ name: 'editQuestionnaireUser', params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid } })
            }
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善问卷基本信息',
              customClass: 'custom_message'
            })
          }
          break
        case 3:
          if (_this.$route.params.qid && _this.$route.params.qid !== '0') {
            if (this.$route.name.indexOf('create') !== -1) {
              _this.$router.push({ name: 'createQuestionnaireBody', params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid } })
            } else {
              _this.$router.push({ name: 'editQuestionnaireBody', params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid } })
            }
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善问卷基本信息',
              customClass: 'custom_message'
            })
          }
          break
      }
    },
    routeChange () {
      switch (this.$route.name) {
        case 'editQuestionnaireBasic':
          this.isActive = 1
          break
        case 'editQuestionnaireUser':
          this.isActive = 2
          break
        case 'editQuestionnaireBody':
          this.isActive = 3
          break
        case 'createQuestionnaireBasic':
          this.isActive = 1
          break
        case 'createQuestionnaireUser':
          this.isActive = 2
          break
        case 'createQuestionnaireBody':
          this.isActive = 3
          break
      }
      this.stepClick(this.isActive)
    },
    checkQuestionnaire: function () {
      const _this = this
      questionnaireApi.checkQuestionnaire({ QuestionnaireId: _this.$route.params.qid }).then(data => {
        const checkInfo = data
        checkInfo.forEach(function (item, index) {
          if (item.Step === 'basic') {
            _this.basicCheck.IsComplete = item.IsComplete
            if (!_this.basicCheck.IsComplete) {
              _this.basicCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.basicCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'user') {
            _this.userCheck.IsComplete = item.IsComplete
            if (!_this.userCheck.IsComplete) {
              _this.userCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.userCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'body') {
            _this.bodyCheck.IsComplete = item.IsComplete
            if (!_this.bodyCheck.IsComplete) {
              _this.bodyCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.bodyCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
        })
        if (_this.basicCheck.IsComplete && _this.userCheck.IsComplete && _this.bodyCheck.IsComplete) {
          _this.isComplete = true
        } else {
          _this.isComplete = false
        }
      }).catch(err => {
        return err
      })
    },
    startQuestionnaire: function () {
      const _this = this
      _this.$confirm('发布问卷会下发问卷到答卷人，确认发布该问卷吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('问卷发布中，这需要一点时间，请稍等。不要关闭页面！')
        questionnaireApi.startQuestionnaire({
          QuestionnaireId: _this.$route.params.qid
        }).then(data => {
          const questionnaireNum = data
          _this.$message({
            type: 'success',
            message: '问卷发布成功！',
            customClass: 'custom_message'
          })
          questionnaireApi.getQuestionnaireDetail({
            questionnaireId: _this.$route.params.qid
          }).then(data => {
            _this.questionnaireInfo = data
            openLoading.close()
            if (questionnaireNum > 0) {
              _this.$router.push({
                name: 'watchQuestionnaire',
                params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid, type: _this.questionnaireInfo.Type }
              })
            } else {
              //   _this.$router.push({
              //     name: 'questionnaireGuidePage',
              //     params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid, type: _this.questionnaireInfo.Type }
              //   })
              _this.$router.push({
                name: 'watchQuestionnaire',
                params: { mid: _this.$route.params.mid, qid: _this.$route.params.qid, type: _this.questionnaireInfo.Type }
              })
            }
          }).catch(err => {
            openLoading.close()
            return err
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消发布问卷操作',
          customClass: 'custom_message'
        })
      })
    },
    getQuestionnaireInfo: function () {
      const _this = this
      _this.openLoading()
      if (_this.$route.params.qid !== '0') {
        questionnaireApi.getQuestionnaireDetail({
          questionnaireId: _this.$route.params.qid
        }).then(data => {
          _this.questionnaireInfo = data
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      } else {
        _this.questionnaireInfo.State = 0
        _this.getMeetingInfo()
        _this.openLoading().close()
      }
    },
    getMeetingInfo: function () {
      const _this = this
      _this.openLoading()
      _this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: _this.$route.params.mid
      }).then(data => {
        _this.questionnaireInfo.MeetingVerify = data.Verify
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    switchFullScreen: function () {
      const _this = this
      _this.isFullScreen = !_this.isFullScreen
      _this.homeSwitchFullScreen()
    }
  },
  computed: {

  },
  created () {
    if (this.$route.params.qid === '0') {
      this.formTitle = '新增问卷'
    } else {
      this.formTitle = '编辑问卷'
    }
    this.routeChange()
    this.getQuestionnaireInfo()
  },
  watch: {
    $route () {
      if (this.$route.name === 'createQuestionnaireBasic' && this.$route.params.qid === '0') {
        this.basicCheck = {
          IsComplete: false,
          NoCompleteMessages: '基本信息不完善'
        }
        this.userCheck = {
          IsComplete: false,
          NoCompleteMessages: '未选答卷人'
        }
        this.bodyCheck = {
          IsComplete: false,
          NoCompleteMessages: '未添加题目'
        }
      }
    }
  }
}
</script>
<style lang="less">
.step_box {
  width: 100%;
  padding: 10px 0px 15px 0px;
}
.step_item {
  width: 100%;
  height: 70px;
  border-radius: 3px;
  background-color: #fff;
  color: #5e6d82;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.step_item:hover {
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.step_item_active {
  width: 100%;
  height: 70px;
  border-radius: 3px;
  background-color: #409eff;
  //background-color: #67c23a;
  color: #fff;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.step_item_active:hover {
  //background-color: #85ce61;
  background-color: #66b1ff;
}
.step_item_complete {
  width: 100%;
  height: 82px;
  border-radius: 3px;
  background-color: #67c23a;
  color: #fff;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.step_item_complete:hover {
  background-color: #85ce61;
}
.step_num {
  font-style: italic;
  font-size: 40px;
  font-weight: 900;
  padding: 0px 15px 0px 0px;
  font-family: Arial, Verdana, Sans-serif;
  letter-spacing: 8px;
}
.step_icon {
  font-size: 20px;
  margin-right: 20px;
  position: absolute;
  top: 3px;
  left: 15px;
  color: #67c23a;
}
.step_content {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.step_title {
  font-size: 18px;
  font-weight: 700;
}
.step_desc {
  font-size: 12px;
}
.check_success_box {
  height: 16px;
  width: 120px;
  background-image: url('../../../../assets/images/vote/success_tip1.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px 6px 0px 0px;
  color: #fff;
  text-align: left;
  font-size: 8px;
  padding: 0px 5px;
  word-spacing: 3px;
}
.check_warning_box {
  height: 16px;
  width: 180px;
  background-image: url('../../../../assets/images/vote/warning_tip1.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px 6px 0px 0px;
  color: #fff;
  text-align: left;
  font-size: 8px;
  padding: 0px 5px;
  word-spacing: 3px;
}
.check_none_box {
  height: 16px;
  width: 90px;
  border-radius: 6px 6px 0px 0px;
}
</style>
